import React from "react";

type ToggleValue = "known" | "learning";

interface KnownLearningToggleProps {
  value: ToggleValue;
  onChange: (value: ToggleValue) => void;
  knownCount: number;
  learningCount: number;
  className?: string;
}

const KnownLearningToggle: React.FC<KnownLearningToggleProps> = ({
  value,
  onChange,
  knownCount,
  learningCount,
  className = "",
}) => {
  const nonSelectedGray = "bg-[var(--color-grey-lightest)]";
  return (
    <div className="bg-[var(--color-grey-lightest)] p-[5px] rounded-full">
      <div
        className={
          `relative p-[2px] rounded-full w-full font-bold text-base z-0 ${className}` +
          nonSelectedGray
        }
      >
        {/* Background highlight */}
        <div
          className={`absolute h-full inset-0 my-auto transition-all duration-200 ease-in-out rounded-full`}
          style={{
            width: "50%",
            left: value === "learning" ? "0%" : "50%",
            backgroundColor: "var(--color-grey)",
          }}
        />

        {/* Buttons */}
        <div className="relative flex w-full">
          <button
            onClick={() => onChange("learning")}
            className={`
            flex-1 py-[2px] px-4 text-base transition-colors duration-200
            ${value === "learning" ? "text-white" : "text-[var(--color-grey)]"}
            relative z-10
          `}
          >
            Learning {learningCount !== undefined && ` (${learningCount})`}
          </button>
          <button
            onClick={() => onChange("known")}
            className={`
            flex-1 py-[2px] px-4 text-base transition-colors duration-200
            ${value === "known" ? "text-white" : "text-[var(--color-grey)]"}
            relative z-10
          `}
          >
            Known {knownCount !== undefined && ` (${knownCount})`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default KnownLearningToggle;
